
import { useState, useEffect } from "react";
import styles from "../index.less";
import Blank from "../components/blank";
import evaluate3 from "../../../asset/img/login/evaluate3.png";
import evaluate4 from "../../../asset/img/login/evaluate4.png";
import evaluate5 from "../../../asset/img/login/evaluate5.png";
import { getEvaluationsByHospital } from "api/hospital";
import Pagination from "../components/pagination";
import { departNav, hospitalNav } from "utils/hospital";

// 1:图文问诊，2:电话问诊，3:视频问诊
const serviceType: any = {
  1: '图文问诊',
  2: '电话问诊',
  3: '视频问诊',
};

const EvaluateList = ({ tabIndex, pageId, showAll, current, name, departId }: any) => {
  const moreUrl = departId ? departNav(`${pageId}-${departId}`)[tabIndex]?.url : hospitalNav(pageId)[tabIndex]?.url;
  const [idnexID, setIdnexID] = useState<any>(3);
  const [data, setData] = useState<any>();
  const [nextPage, setNextPage] = useState<boolean>(false);
  const [pageNo, setPageNo] = useState<number>(current || 1);
  useEffect(() => {
    getEvaluations(pageId);
  }, []);
  // 获取评价列表
  const getEvaluations = (hospitalId: any) => {
    getEvaluationsByHospital({hospitalId, secondDepartmentId: departId, tenantId: 'JD8888', pageNo, pageSize: 10 }).then((res: any) => {
      console.log(res, 444);
      setData(res?.data || []);
      setNextPage(res?.nextPage || false);
      setPageNo(res?.pageNo || 1);
    })
  }
  const timeStampFun = (timeStamp: string | number | Date) => {
    const date = new Date(timeStamp);
    const year = date.getFullYear();
    const month = Number(date.getMonth()) + 1;
    const day = date.getDate();
    let hour: any = date.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    let minute: any = date.getMinutes();
    if (minute < 10) {
      minute = "0" + minute;
    }
    return year + "." + month + "." + day;
  };

  if(!data?.length){
    return null;
  }

  return data ?  
    <Blank className={styles.evaluate} title={`${name || ''}患者评价`} moreUrl={moreUrl}>
      {/* 患者评价列表 */}
      <div className={styles.evaluateList}>
        <ul>
          {data && data?.length > 0 ? (
            data.map(
              (val: any, idnex: any) => {
                return (
                  <li key={idnex} className={(showAll || idnex < idnexID)  ? '' : styles.displayNone}>
                    <div className={styles.evaluateListTop}>
                      <div className={styles.evaluateListTopLeft}>
                        <div className={styles.evaluateListTopName}>
                          {val.patientName}
                        </div>
                        <span />
                        <div className={styles.evaluateListTopLeftImg}>
                          {[1, 2, 3, 4, 5].map(
                            (itme: any, index: any) => {
                              if (itme <= val.compositeScore) {
                                return (
                                  <img
                                    key={index}
                                    src={evaluate3}
                                    alt=""
                                  />
                                );
                              } else {
                                return (
                                  <img
                                    key={index}
                                    src={evaluate4}
                                    alt=""
                                  />
                                );
                              }
                            }
                          )}
                        </div>
                        <div className={styles.evaluateListTopEvaluea}>
                          回复质量：{val.replyQualityScoreDesc || '暂无'}
                          <span />
                          服务态度：{val.serviceAttitudeScoreDesc || '暂无'}
                          <span />
                          回复速度：{val.replySpeedScoreDesc || '暂无'}
                        </div>
                      </div>
                      <div className={styles.evaluateListTopRight}>
                        {timeStampFun(val.created)}
                      </div>
                    </div>
                    <div className={styles.evaluateListText}>
                      {val.content || val?.diseaseDescription || "此用户未填写评价内容"}
                    </div>
                    <div className={styles.evaluateListButtom}>
                      {/* {val?.disease && (
                        <p>确诊疾病：{val?.disease}</p>
                      )} */}
                      {val?.serviceType && (
                        <span>{serviceType[val.serviceType]}</span>
                      )}
                    </div>
                  </li>
                );
              }
            )
          ) : (
            <div className={styles.noData}>暂无患者评价</div>
          )}
        </ul>
      </div>
      {/* 展开更多 */}
      { !showAll && data?.length > 0 &&
        <div className={styles.evaluateListMore}>
          <p
            onClick={() => {
              if (idnexID < 9) {
                setIdnexID(10);
              }
            }}
          >
            {data &&
              idnexID < 9 ? (
              <>
                <span>展开更多</span>
                <img src={evaluate5} alt="" />
              </>
            ) : null}
          </p>
        </div>
      }
      {showAll && data?.length > 0 &&
        <Pagination
          pageId={pageId}
          current={current}
          nextPage={nextPage}
          nextUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${+pageNo+1}/dianpinglist`}
          preUrl={`/hospital${departId ? `/department` : ''}/${pageId}${departId ? `-${departId}` : ''}-${+pageNo-1}/dianpinglist`}
        />
      }
    </Blank> : <></>
}

export default EvaluateList;